import {
  IconButton,
  Text,
  Icon,
  Flex,
  type FlexProps,
  type ButtonProps,
} from '@/ui';

type Size = ButtonProps['size'];

type Props = FlexProps & {
  numPages: number;
  currentPage: number;
  isDisabled: boolean;
  size?: Size;
  colorScheme?: ButtonProps['colorScheme'];
  variant?: ButtonProps['variant'];
  onNext: () => void;
  onPrev: () => void;
};

const SizeToTextSize: Record<string, Size> = {
  xs: 'sm',
  sm: 'md',
};

export const Pagination = ({
  numPages,
  currentPage,
  isDisabled,
  size = 'sm',
  colorScheme = 'dark',
  variant = 'solid',
  onNext,
  onPrev,
  ...props
}: Props) => {
  return (
    <Flex align="center" gap="2" justify="center" {...props}>
      <IconButton
        aria-label="Previous page"
        colorScheme={colorScheme}
        icon={<Icon icon="ChevronLeft" />}
        isDisabled={isDisabled || currentPage === 1}
        size={size}
        variant={variant}
        onClick={onPrev}
      />
      <Text
        fontSize={SizeToTextSize[String(size)] || size}
        mx="2"
        whiteSpace="nowrap"
      >
        {currentPage} / {numPages}
      </Text>
      <IconButton
        aria-label="Next page"
        colorScheme={colorScheme}
        icon={<Icon icon="ChevronRight" />}
        isDisabled={isDisabled || currentPage === numPages}
        size={size}
        variant={variant}
        onClick={onNext}
      />
    </Flex>
  );
};
